import { Component, OnInit } from '@angular/core';
import { TranslationConstants } from '../../../../../shared/constants';
import { forkJoin, Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import {
  ClosableModalWithErrorResponseModel
} from '../../../../../shared/components/base/closable-modal-with-error-response-model';

import { NotificationService, PbasService } from '../../../../../shared/services';
import { ModalService } from '../../../../../shared/modules/modal';
import {
  MajorClassificationsModalPayload,
  CharacterizeTestedPartyOptionTypeErrorResponse,
} from '../../../../../shared/models';

@Component({
  selector: 'provide-classifications-modal',
  templateUrl: './provide-classifications-modal.component.html'
})
export class ProvideClassificationsModalComponent
  extends ClosableModalWithErrorResponseModel<CharacterizeTestedPartyOptionTypeErrorResponse> implements OnInit {

  data: MajorClassificationsModalPayload;
  test: true;
  majorClassifications = [];
  selectedMajorClassificationIds = [];

  constructor(
    protected modalService: ModalService,
    protected notificationService: NotificationService,
    private _pbasService: PbasService,
    private _translateService: TranslateService
  ) {
    super(notificationService, modalService);
    this.validationErrors = new CharacterizeTestedPartyOptionTypeErrorResponse();
  }

  ngOnInit(): void {
    this.translateMajorServiceClassificationNames();
    this.listenForErrorMessages();
    this.getSelectedMajorClassifications();
  }

  save(): void {
    this.validateMajorClassificationsSelection();

    if (this.responseErrors.length) {
      return;
    }

    let mjrClsToDelete = [];
    let mjrClsIdsToAdd = [];

    if (this.data.testedPartyMajorClassifications && this.data.testedPartyMajorClassifications.length) {
      mjrClsToDelete = this.data.testedPartyMajorClassifications.filter((tmc) => {
        const selectedId = this.selectedMajorClassificationIds.find(smcId =>
          Number(smcId) === Number(tmc.majorServiceClassificationId)
        );

        return !selectedId;
      });

      mjrClsIdsToAdd = this.selectedMajorClassificationIds.filter((smcId) => {
        const selectedId = this.data.testedPartyMajorClassifications.find(
          tmc => Number(smcId) === Number(tmc.majorServiceClassificationId)
        );

        return !selectedId;
      });
    } else {
      mjrClsIdsToAdd = this.selectedMajorClassificationIds;
    }

    if (mjrClsToDelete.length) {
      this.deleteTestedPartyMajorClasifications(mjrClsToDelete).subscribe(() => {
        if (mjrClsIdsToAdd.length) {
          this.addTestedPartyMajorClasifications(mjrClsIdsToAdd).subscribe(() => {
            this.success();
            this.close();
          });
        } else {
          this.success();
          this.close();
        }
      });
    } else if (mjrClsIdsToAdd.length) {
      this.addTestedPartyMajorClasifications(mjrClsIdsToAdd).subscribe(() => {
        this.success();
        this.close();
      });
    } else {
      this.success();
      this.close();
    }
  }

  private translateMajorServiceClassificationNames(): void {
    this.data.allMajorServiceClassifications.forEach((majorServiceClassification) => {
      majorServiceClassification.name = this._translateService.instant(majorServiceClassification.name);
    });
    
    this.data.allMajorServiceClassifications.sort((major1, major2) => {
      return major1.name > major2.name ? 1 : -1;
    });
  }

  private validateMajorClassificationsSelection(): void {
    this.responseErrors = [];

    if (this.selectedMajorClassificationIds.length > 3) {
      this.responseErrors.push(TranslationConstants.MAJOR_CLASSIFICATION_MAX_3_ERROR);
    }

    if (this.selectedMajorClassificationIds.length === 0) {
      this.responseErrors.push(TranslationConstants.MAJOR_CLASSIFICATION_REQUIRED);
    }
  }

  private deleteTestedPartyMajorClasifications(testedPartyMajorClassifications): Observable<any[]> {
    const observables = [];
    testedPartyMajorClassifications.forEach((classification) => {
      let testedPartyMinorClassifications = [];

      if (classification.minorServiceClassifications && classification.minorServiceClassifications.length) {
        testedPartyMinorClassifications = classification.minorServiceClassifications;
      }

      testedPartyMinorClassifications.forEach((minorClass) => {
        const minorObsrv = this._pbasService.deleteMinorServiceClassificationsForTestedParty(
          this.data.testedParty.pba.pbaId, minorClass.minorServiceClassificationId
        );

        observables.push(minorObsrv);
      });

      const obsrv = this._pbasService.deleteMajorServiceClassificationsForTestedParty(
        this.data.testedParty.pba.pbaId, classification.majorServiceClassificationId
      );

      observables.push(obsrv);
    });

    return forkJoin(observables);
  }

  private addTestedPartyMajorClasifications(majorClassificationIds): Observable<any[]> {
    const observables = [];
    majorClassificationIds.forEach((classificationId) => {
      const obsrv = this._pbasService.addMajorServiceClassificationsForTestedParty(
        this.data.testedParty.pba.pbaId, classificationId
      );

      observables.push(obsrv);
    });

    return forkJoin(observables);
  }

  private getSelectedMajorClassifications(): void {
    for (const classification of this.data.testedPartyMajorClassifications) {
      if (classification.majorServiceClassificationId) {
        this.selectedMajorClassificationIds.push(classification.majorServiceClassificationId);
      }
    }
  }
}
